import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import StickyCTA from '../../components/feature/StickyCTA';
import { modules } from '../../mocks/modules';
import { Link } from 'react-router-dom';

export default function ModulosPage() {
  const [openModule, setOpenModule] = useState<number | null>(null);

  return (
    <>
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="font-display text-5xl lg:text-6xl font-bold text-purple-900 mb-6">
              10 Módulos de Transformação
            </h1>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
              Cada módulo foi cuidadosamente desenvolvido para construir sua jornada de <strong>liderança feminina</strong>, 
              do autoconhecimento ao legado que você deseja deixar
            </p>
          </div>

          <div className="space-y-6">
            {modules.map((module) => (
              <div
                key={module.id}
                className={`bg-white border-2 rounded-2xl overflow-hidden transition-all duration-300 ${
                  openModule === module.id
                    ? 'border-purple-400 shadow-xl'
                    : 'border-purple-100 hover:border-purple-300'
                }`}
              >
                <button
                  onClick={() => setOpenModule(openModule === module.id ? null : module.id)}
                  className="w-full p-8 flex items-center justify-between cursor-pointer hover:bg-purple-50 transition-colors"
                >
                  <div className="flex items-center space-x-6">
                    <div className="w-14 h-14 flex items-center justify-center flex-shrink-0 bg-gold-500 rounded-full">
                      <span className="text-white font-bold text-xl">
                        {String(module.id).padStart(2, '0')}
                      </span>
                    </div>
                    <h2 className="text-2xl font-bold text-purple-900 text-left">
                      {module.title}
                    </h2>
                  </div>
                  <i
                    className={`ri-arrow-down-s-line text-3xl text-purple-600 flex-shrink-0 transition-transform duration-300 ${
                      openModule === module.id ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>

                {openModule === module.id && (
                  <div className="px-8 pb-8 bg-gradient-to-b from-purple-50 to-white">
                    <div className="pl-20">
                      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                        {module.description}
                      </p>

                      <div className="mb-6">
                        <h3 className="text-lg font-bold text-purple-900 mb-4">
                          Objetivos do módulo:
                        </h3>
                        <ul className="space-y-2">
                          {module.objectives.map((objective, index) => (
                            <li key={index} className="flex items-start space-x-3">
                              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                                <i className="ri-check-line text-gold-500 text-xl"></i>
                              </div>
                              <span className="text-gray-700">{objective}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div>
                        <h3 className="text-lg font-bold text-purple-900 mb-4">
                          Ferramentas práticas:
                        </h3>
                        <div className="flex flex-wrap gap-3">
                          {module.tools.map((tool, index) => (
                            <span
                              key={index}
                              className="bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium"
                            >
                              {tool}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <Link
              to="/inscricao"
              className="inline-block bg-gold-500 text-purple-900 px-12 py-5 rounded-full text-lg font-bold hover:bg-gold-400 transition-all hover:scale-105 shadow-lg whitespace-nowrap"
            >
              Eu quero transformar minha liderança
            </Link>
          </div>
        </div>
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}
